import React, {PureComponent} from 'react'
import Typography from "@mui/material/Typography";
import { blue, green, purple, yellow, red } from "@mui/material/colors";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import CheckIcon from '@mui/icons-material/Check';
import { HexColorPicker } from "react-colorful";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import Divider from "@mui/material/Divider";
import CardContent from "@mui/material/CardContent";
import {Popover} from "@mui/material";
import SmallBadge from "../custom/SmallBadge";
import CreateIcon from '@mui/icons-material/Create';

const PRESET_COLORS = [blue[500], green[500], red[500], yellow[600]];

class ColorSelector extends PureComponent {
	/**
	 * @param props Containing:
	 *      'color': The color.
	 *      'updateColorValueParentFunc': The function to call to update the color.
	 */
	constructor(props) {
		super(props);
		this.state = {
			color: props.color ?? blue[500],
			customColorPickAnchorEl: null,
		};
	}

	componentWillReceiveProps(nextProps, nextContext) {
		this.setState({
			color: nextProps.color ?? blue[500],
		})
	}

	updateStateInputColorValue = (color) => {
		this.props.updateColorValueParentFunc(color);
	}

	openCustomColorPicker = (event) => {
		this.setState({
			customColorPickAnchorEl: event.currentTarget,
		});
	}

	closeCustomColorPicker = () => {
		this.setState({
			customColorPickAnchorEl: null,
		});
	}

	isCustomColor = () => {
		return !PRESET_COLORS.includes(this.state.color);
	}

	renderCustomColorPicker = () => {
		return <Popover
			open={this.state.customColorPickAnchorEl !== null}
			anchorEl={this.state.customColorPickAnchorEl}
			onClose={this.closeCustomColorPicker}
			anchorOrigin={{
				vertical: 'bottom',
				horizontal: 'center',
			}}
			transformOrigin={{
				vertical: 'top',
				horizontal: 'center',
			}}
		>
			<Card>
				<CardHeader subheader={<Typography variant='h6'>Pick Custom Color</Typography>}/>

				<Divider light/>

				<CardContent>
					<HexColorPicker color={this.state.color} onChange={this.updateStateInputColorValue}/>
				</CardContent>
			</Card>

		</Popover>;
	}

	renderSwatch = (color) => {
		const isSelected = this.state.color === color;
		return (
			<IconButton size='small' onClick={() => this.updateStateInputColorValue(color)}>
				<Box sx={{
					width: 40,
					height: 40,
					borderRadius: '50%',
					bgcolor: color,
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					border: isSelected ? '2.5px solid' : '2.5px solid transparent',
					borderColor: isSelected ? 'text.primary' : 'transparent',
				}}>
					{isSelected && <CheckIcon sx={{ color: 'white', fontSize: 20 }} />}
				</Box>
			</IconButton>
		);
	}

	render() {
		const isCustom = this.isCustomColor();

		return (
			<>
				{this.renderCustomColorPicker()}

				<Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25 }}>
					{PRESET_COLORS.map(color => (
						<React.Fragment key={color}>
							{this.renderSwatch(color)}
						</React.Fragment>
					))}
					<IconButton size='small' onClick={this.openCustomColorPicker}>
						<SmallBadge color={'rgba(50,50,50,0.4)'} icon={<CreateIcon style={{ fontSize: '1.15rem'}}/>}>
							<Box sx={{
								width: 40,
								height: 40,
								borderRadius: '50%',
								bgcolor: isCustom ? this.state.color : '#9f9f9f',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								border: isCustom ? '2.5px solid' : '2.5px solid transparent',
								borderColor: isCustom ? 'text.primary' : 'transparent',
							}}>
								{isCustom && <CheckIcon sx={{ color: 'white', fontSize: 20 }} />}
							</Box>
						</SmallBadge>
					</IconButton>
				</Box>
			</>
		);
	}
}

export default ColorSelector;
